import React, { useEffect, useState } from "react";
import { Card, CardBody, Button, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { useNavigate } from "react-router-dom";
import { PAGEPATHS } from "components/Common/Constant";
import ReportEditModal from "./ReportEditModal"; // you'll create this
import DeleteConfirmModal from "./DeleteConfirmModal"; // you'll create this
import { showToaster } from "components/Common/common";
import { VIEW_TYPE_OPTIONS } from "components/Common/ApiManagement/apiServices";


const SavedReportsTable = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const fetchReports = async () => {
    try {
      const res = await axiosInstance.post(ApiNames.CUSTOM_REPORT_LIST_ALL);
      if (res.data?.status && Array.isArray(res.data.data)) {
        setReports(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching saved reports:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleEditClick = report => {
    setSelectedReport(report);
    setEditModalOpen(true);
  };

  const handleDeleteClick = report => {
    setSelectedReport(report);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const res = await axiosInstance.post(ApiNames.CUSTOM_REPORT_DELETE, {
        reportName: selectedReport.reportName,
      });
      if (res.data?.status) {
        showToaster(1, "Report Deleted successfully");
        setReports(reports.filter(r => r.reportName !== selectedReport.reportName));
      }
    } catch (err) {
      console.error("Error deleting report:", err);
    } finally {
      setDeleteModalOpen(false);
    }
  };

  if (loading) return <Spinner className="mt-4" color="primary" />;

  return (
    <>
      <Card className="mt-4">
        <CardBody>
          <div className="d-flex justify-content-end mb-3">
            <Button color="secondary" onClick={() => navigate(PAGEPATHS.customReportLayout)}>
              Back
            </Button>
          </div>
          <h5 className="mb-3">Saved Reports</h5>
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Report Name</th>
                  <th>Compliance Areas</th>
                  <th>Scan Group</th>
                  <th>Scan Name</th>
                  <th>Category</th>
                  <th>Sub-Category</th>
                  <th>View Types</th>
                  <th>Assign To</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report, idx) => (
                  <tr key={idx}>
                    <td>{report.reportName}</td>
                    <td>{(report.areaName || []).join(", ")}</td>
                    <td>{(report.scanGroup || []).join(", ")}</td>
                    <td>{(report.scanName || []).join(", ")}</td>
                    <td>{(report.category || []).join(", ")}</td>
                    <td>{(report.scanSubcat || []).join(", ")}</td>
                   <td>
  {(report.viewTypes || [])
    .map(vt => {
      const match = VIEW_TYPE_OPTIONS.find(opt => opt.value === vt);
      return match?.label || vt;
    })
    .join(", ")}
</td>
                    <td>
                      {report.assignTo === "everyone"
                        ? "Everyone"
                        : (report.assignedOrganizations || [])
                            .map(org => org.name)
                            .join(", ") || "—"}
                    </td>
                    <td>
                      <Button size="sm" color="info" onClick={() => handleEditClick(report)}>Edit</Button>{" "}
                      <Button size="sm" color="danger" onClick={() => handleDeleteClick(report)}>Delete</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>

      {/* Edit Modal */}
      {selectedReport && (
        <ReportEditModal
          isOpen={editModalOpen}
          toggle={() => setEditModalOpen(!editModalOpen)}
          reportName={selectedReport?.reportName} 
          onSaved={() => {
            setEditModalOpen(false);
            fetchReports();
          }}
        />
      )}

      {/* Delete Confirmation Modal */}
      {selectedReport && (
        <DeleteConfirmModal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={handleDeleteConfirm}
          title={`Delete report "${selectedReport.reportName}"?`}
        />
      )}
    </>
  );
};

export default SavedReportsTable;
